import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.577 3.592a9.5 9.5 0 0 1 10.777 1.349A9.5 9.5 0 0 1 20.7 8.194l.995-2.933.029-.071a.75.75 0 0 1 1.413.48l-.02.073-1.613 4.754a.75.75 0 0 1-.951.47l-.195-.066a1 1 0 0 1-.088-.03l-4.472-1.516-.072-.029a.75.75 0 0 1 .48-1.414l.074.022 3.13 1.061A7.995 7.995 0 0 0 8.275 4.92l-.277.154a8 8 0 0 0-1.354 12.873l.24.207a8 8 0 0 0 4.278 1.803l.314.028a8 8 0 0 0 4.522-1.056.75.75 0 0 1 .75 1.3 9.5 9.5 0 0 1-5.37 1.252l-.373-.032a9.5 9.5 0 0 1-5.08-2.142l-.283-.246A9.5 9.5 0 0 1 7.248 3.773z"
    }, null, -1)
  ]))]))
}
export default { render: render }